import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "doc-badges" }

import Badge from '@/app/components/Badge.vue'
import { readingMinutes } from '@/helpers/time'
import type { DocListItem } from '@/models/interfaces'


export default /*@__PURE__*/_defineComponent({
  __name: 'DocBadges',
  props: {
    doc: {},
    free: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.free)
      ? (_openBlock(), _createBlock(Badge, {
          key: 0,
          primary: ""
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("Free", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(Badge, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(readingMinutes)(__props.doc.summary_words)) + " min", 1)
      ]),
      _: 1
    }),
    (__props.doc.has_audio)
      ? (_openBlock(), _createBlock(Badge, {
          key: 1,
          class: "doc-badges__audio",
          icon: "iaudio",
          "aria-label": "Audio available"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})